import { Box, Divider, Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';
import { useTranslations } from 'hooks/useTranslations';

const PriceDisplay = ({ plan }) => {
  const { t } = useTranslations();

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      width="100%"
      gap={0.5}
    >
      <Typography
        component="div"
        variant="h6"
        style={{
          fontWeight: '400',
          paddingLeft: 1,
          lineHeight: '15px',
          fontSize: '13px',
          color: saasModernTheme.colors.black,
        }}
      >
        <span>
          {plan?.maxUser && (
            <span style={{ color: saasModernTheme.colors.secondary }}>
              {plan.maxUser} {t('pricing.user')}{' '}
            </span>
          )}
          / {t('pricing.month')}
          <br />
          <span style={{ color: saasModernTheme.colors.grayBorder }}> {t('pricing.billed.annually')}</span>
        </span>
      </Typography>
      <Divider
        sx={{
          width: 50,
          border: `1px solid ${saasModernTheme.colors.grayBorder}`,
        }}
      />
      <Typography
        component="div"
        variant="h6"
        style={{
          fontWeight: '400',
          paddingLeft: 1,
          lineHeight: '12px',
          fontSize: '13px',
          color: saasModernTheme.colors.black,
        }}
      >
        € {plan.code === 'FREE' ? 0 : plan.price} {t('pricing.billed.monthly')}
      </Typography>
    </Box>
  );
};

export default PriceDisplay;
